module.exports = __webpack_public_path__ + "img/logo-jkp.6332e386.png";